import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { FaSearch } from 'react-icons/fa';
import { SearchInput } from '../pages/Theme';

const SearchBar = ({ setSearchField, onClick=()=>{}, clear,placeholder="Type to Search..." }) => {

    const inputRef = useRef();

    useEffect(() => {
        inputRef.current.value = "";
    }, [clear])
    const handleChange = e => {
        setSearchField(e.target.value)
    }

    const handleKeypress = e => {
        if (e.key === 'Enter') {
            e.preventDefault()
            onClick()
        }
    };

    return (
        <div className='flex relative  w-full h-10 rounded-lg overflow-hidden'>
            <input
                className='h-full w-full bg-white borderf-1 px-2 pr-9 flex items-center  lg:px-3 lg:pr-9 greyColor'
                type='search'
                placeholder={placeholder}
                onChange={handleChange}
                onKeyPress={handleKeypress}
                id="clearSearch"
                ref={inputRef}
            />
            {/* <SearchInput
                className={`flex items-center be justify-center text-white h-full w-12 cursor-pointer}`}
                onClick={onClick}
            >
                <FaSearch className='w-8 h-8 p-2' />
            </SearchInput> */}
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
                <FaSearch onClick={onClick} style={{ color: '#C3CAD9',fontWeight:400,cursor:'pointer' }} className="w-5 h-5" />
            </div>
        </div>
    )
}

export default SearchBar;
